import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_4 = { class: "breadcrumb align-items-center mb-0 lh-1" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_7 = { class: "fw-medium" }
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = { class: "fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ol", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_RouterLink, {
            to: "/dashboard",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "ri-home-4-line fs-18 text-primary me-1" }, null, -1 /* HOISTED */),
              _createElementVNode("span", { class: "text-secondary fw-medium hover" }, "Dashboard", -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */
          })
        ]),
        (_ctx.subTitle)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.subTitle), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}